import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { CategoryService } from '../../_ecomservices/category.service';
import * as _ from 'lodash';
import { CategoriesComponent } from '../categories/categories.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-category-edit',
  templateUrl: './category-edit.component.html',
  styleUrls: ['./category-edit.component.css']
})
export class CategoryEditComponent implements OnInit {

  seo_metadata = null;

  cat_img: File = null;
  categoryList: any = [];
  categoryImagePreview: string | ArrayBuffer | null = null;

  cat_banner: File = null;
  categoryBannerImagePreview: string | ArrayBuffer | null = null;

  category_edit_form = new FormGroup({
    id: new FormControl(null),
    category_name: new FormControl('', [Validators.required]),
    slug: new FormControl(''),
    cat_desc: new FormControl(''),
    cat_img: new FormControl(null),
    cat_banner: new FormControl(null),
    parent_category_id: new FormControl([]),
    status: new FormControl(),
  });

  constructor(private dialogRef: MatDialogRef<CategoriesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loading: LoadingService,
    private titleService: Title,
    private notificationService: NotificationService,
    private categoryService: CategoryService,) {
    this.loading.spin$.next(true);
    this.onLoadCategories();
    this.onloadCategoryDetails(data.categoryId);
  }

  ngOnInit() {
    this.titleService.setTitle('Edit Category');
  }

  onLoadCategories() {
    var result = this.categoryService.get_categories().subscribe(data => {
      this.categoryList = data['categoryList'];
      this.loading.spin$.next(false);
    });
  }

  onloadCategoryDetails(category_id) {
    this.categoryService.get_category_id(category_id).subscribe(data => {
      console.log(data);
      this.seo_metadata = data['category_data']['seo_metadata'];
      // this.category_edit_form.setValue(_.omit(data['category_data'], 'cat_slug', 'seo_metadata', 'created_at', 'updated_at', 'deleted_at'));
      this.category_edit_form.patchValue({
        id: data['category_data']['id'],
        category_name: data['category_data']['category_name'],
        slug: data['category_data']['slug'],
        cat_desc: data['category_data']['cat_desc'],
        cat_img: data['category_data']['cat_img'],
        cat_banner: data['category_data']['cat_banner'],
        parent_category_id: data['category_data']['parent_category_id'],
        status: data['category_data']['status'],
      });

      this.categoryImagePreview = data['category_data']['cat_img'];
      this.categoryBannerImagePreview = data['category_data']['cat_banner'];
      this.loading.spin$.next(false);
    });
  }

  onSelectCategoryImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.cat_img = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.categoryImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectCategoryBannerImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.cat_banner = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.categoryBannerImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onUpdateCategoryFormSubmit(formData: any) {
    if (this.category_edit_form.valid) {
      this.loading.spin$.next(true);
      this.categoryService.update_category(formData, this.cat_img, this.cat_banner).subscribe(data => {
        console.log(data);
        if (data['status']) {
          this.notificationService.success('Category data updated Successfully.');
          this.onClose();
          this.loading.spin$.next(false);
        }
        else {
          this.notificationService.error(data['error_message']);
          this.loading.spin$.next(false);
        }
      });
    }
  }

  onClose() {
    this.category_edit_form.reset();
    this.dialogRef.close();
  }

  onFileChange(e) {

  }

}
